import { useGetMe } from '@sara/api-client';
import { useParams } from '@tanstack/react-router';

/**
 * Returns the organization that matches the active `:orgSlug` URL param.
 *
 * Returns `{ organization: null }` when the user is on a route without
 * `:orgSlug` (e.g. `/orgs` selector), when the slug does not match any
 * membership, or while `useGetMe` is still loading — callers that need to
 * distinguish "loading" from "no match" should also read `rest.isLoading`.
 */
export function useActiveOrganization() {
  // Cross-cutting hook: callers exist inside and outside the $orgSlug subtree,
  // so we can't use a `from`-scoped useParams. The narrow cast asserts the only
  // param this hook cares about; a future rename would surface in this hook's
  // tests rather than at the type level.
  const params = useParams({ strict: false }) as { orgSlug?: string };
  const { data: me, ...rest } = useGetMe();

  const slug = params.orgSlug;
  const organization = slug
    ? (me?.memberships.find((m) => m.organization.slug === slug)?.organization ?? null)
    : null;

  return { organization, ...rest };
}
